module.exports = __webpack_public_path__ + "static/media/BIFI-BNB-banana.60b5f108.svg";